module.exports = __webpack_public_path__ + "static/media/tenant_default_logo.68d52efb.png";